export default "__VITE_ASSET__sSnQLFkS__"